"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validation_1 = require("../../validation");
const ItemDefinition_1 = require("./ItemDefinition");
const zod_1 = require("zod");
const configSchema = zod_1.z.object({
    switchOn: zod_1.z.boolean((0, validation_1.labelZodErrors)("Switch On")).optional(),
});
const dataSchema = zod_1.z.object({
    switchOn: zod_1.z.boolean((0, validation_1.labelZodErrors)("Switch")),
});
exports.default = new ItemDefinition_1.ItemDefinition("Switch", configSchema, dataSchema, new validation_1.ValidatorPipeline("Switch Config Validator", []), new validation_1.ValidatorPipeline("Switch Data Validator", [
    (0, validation_1.createZodSchemaValidator)(["data", "switchOn"], zod_1.z.literal(true, (0, validation_1.customZodError)("Must be switched on."))),
]));
//# sourceMappingURL=Switch.js.map